module.exports = __webpack_public_path__ + "img/friendly-room-2.1fcfdcca.jpg";